import { BILLING_CYCLE } from '@/common/constants';
import { locale, momentI18nMap } from '@/plugins/i18n';

export const i18n_cycle = function (cycle) {
    if (cycle === BILLING_CYCLE.ANNUAL) return this.$t('billing.cycle.annual');
    if (cycle === BILLING_CYCLE.MONTHLY) return this.$t('billing.cycle.monthly');
    if (cycle === BILLING_CYCLE.QUARTERLY) return this.$t('billing.cycle.quarterly');
    if (cycle === BILLING_CYCLE.TWO_YEARS) return this.$t('billing.cycle.two_years');
    if (cycle === BILLING_CYCLE.THREE_YEARS) return this.$t('billing.cycle.three_years');
    if (cycle === BILLING_CYCLE.PAY_AS_YOU_GO) return this.$t('billing.pay_you_go');
    return cycle;
};

export const getPbxContactSalesLink = function () {
    const lang = momentI18nMap[locale] || 'en';
    return `https://explore.zoom.us/${lang}/products/zoom-phone/plans-pricing`
}

export const getCommonContactSalesLink = function () {
    const lang = momentI18nMap[locale] || 'en';
    return `https://explore.zoom.us/${lang}/contactsales/`
}
